import { getTotal } from '@wix/ambassador-media-quota-v1-total/http';
import { Projection } from '@wix/ambassador-media-quota-v1-total/types';
import { HttpClient } from '@wix/http-client';
import { getLocale } from '../../../env/getLocale';
import { IStorageQuotaDataBase } from './types';

const enrichUpgradeUrl = (upgradeUrl?: string): string | undefined => {
  if (!upgradeUrl) {
    return undefined;
  }

  const url = new URL(upgradeUrl);
  url.searchParams.append('referralAdditionalInfo', 'media_manager_storage_upgrade');
  url.searchParams.append('locale', getLocale());
  return url.toString();
};

export const fetchQuotaData = async (metaSiteToken?: string): Promise<IStorageQuotaDataBase> => {
  if (!metaSiteToken) {
    throw new Error(`Unable to fetch storage quota data. metaSiteToken is ${metaSiteToken}`);
  }

  const httpClient = new HttpClient({
    baseURL: '/_api/media-quota-server',
    getAppToken: () => metaSiteToken,
  });

  const quotaResponse = await httpClient.request(getTotal({ projection: Projection.QUOTA_AND_USAGE }));
  const quotaInfo = quotaResponse.data.total;
  const usage = +quotaInfo.usage.storage;
  const quota = +quotaInfo.quota.storage;
  const { upgradeUrl } = quotaInfo.quota.plans;

  return {
    usage: { ...quotaInfo.usage, storage: usage },
    quota: {
      ...quotaInfo.quota,
      storage: quota,
      plans: { ...quotaInfo.quota.plans, upgradeUrl: quota !== -1 ? enrichUpgradeUrl(upgradeUrl) : undefined },
    },
  };
};
